import { FieldHookConfig, useField } from "formik";
import React from "react";
import { Form, Row } from "react-bootstrap";

export interface OdsInputProps {
    label: string;
}

const OdsInput: React.FC<OdsInputProps & FieldHookConfig<string>> = ({
    label,
    ...props
}) => {
    const [field, meta, helpers] = useField(props);

    return (
        <Row>
            <Form.Group controlId={field.name}>
                <Form.Label>{label}</Form.Label>
                <Form.Control 
                    name={field.name}
                    type="text" 
                    placeholder={label} 
                    value={field.value} 
                    onChange={field.onChange} 
                    onBlur={field.onBlur}
                    isInvalid={!!meta.touched && !!meta.error}
                    disabled={props.disabled}
                />
                <Form.Control.Feedback type="invalid">
                    {meta.error}
                </Form.Control.Feedback>
            </Form.Group>
        </Row>
    )
};

export default OdsInput;
